import styled from '@emotion/styled';
import capitalize from 'lodash/capitalize';
import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import * as S from 'src/modules/programs/stepComponents/styles';
import glassesIcon from 'src/public/img/icon-glasses.svg';
import { color, font } from 'src/shared/styles/variables';

import { ProgramWeek } from '../models/programs';

const SneakPeek = styled('h4')(
    {
        color: color.mamba,
        paddingLeft: '2rem',

        span: {
            position: 'relative',
            color: color.scooter,
            ...font.heavy(font.size.large),

            '&:before': {
                content: '""',
                position: 'absolute',
                width: '1.5rem',
                height: '1.5rem',
                top: -2,
                left: -34,
                backgroundImage: `url(${glassesIcon})`,
                backgroundSize: 'contain',
            },
        },
    },
    font.roman(font.size.large),
);

interface Props extends WithTranslation {
    week: ProgramWeek;
    programTitle: string;
}

class CongratulationsStepContainer extends React.Component<Props> {
    public render(): JSX.Element {
        const { week, t } = this.props;

        return (
            <S.ContentRow>
                <S.ContentColumn textalign="center">
                    <S.StepHeading>{t('steps.congratulations.heading')}</S.StepHeading>
                    <S.StepDescription small>
                        {t('steps.congratulations.weekInfo')} {week.readableWeekNumber}:{' '}
                        {capitalize(week.title)}
                    </S.StepDescription>
                    <S.StepIcon centered iconUrl={week.congratulationsIconUrl || week.iconUrl} />
                    {week.congratulationsSneakPeek && (
                        <SneakPeek>
                            <span>{t('steps.congratulations.sneakPeek')}: </span>
                            {week.congratulationsSneakPeek}
                        </SneakPeek>
                    )}
                </S.ContentColumn>
            </S.ContentRow>
        );
    }
}

export const CongratulationsStep = withTranslation('programs')(CongratulationsStepContainer);
